<template>
  <div class="flex bg-white items-center px-2 rounded-lg text-xs mx-1 min-w-fit">
    {{ $t("reports.filters.duration") }}
    <DatePicker
      v-model="duration"
      auto-apply
      time-picker
      enable-seconds
      :close-on-auto-apply="false"
      :start-time="durationStart"
      :placeholder="$t('reports.filters.duration_placeholder')"
      text-input
      @update:model-value="handleDurationChange"
    >
      <template #input-icon>
        <v-icon class="input-slot-image ml-2">mdi-timelapse</v-icon>
      </template>
    </DatePicker>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'FilterDuration',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      duration: this.modelValue,
      durationStart: { hours: 0, minutes: 0, seconds: 0 }
    };
  },
  methods: {
    handleDurationChange(value) {
      this.duration = value;
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    },
    getFormattedDuration() {
      if (!this.duration) return '';
      return moment(this.duration).format("HH:mm:ss");
    }
  },
  watch: {
    modelValue(newValue) {
      this.duration = newValue;
    }
  }
};
</script> 